import { chatsApi, MAX_INLINE_IMAGE_BYTES } from './api.js';
export const MAX_FILE_BYTES = 100 * 1024 * 1024;
export const FILE_TOO_BIG = 'That file is too big to send from here.';
const imageTypes = new Set(['image/png', 'image/jpeg', 'image/gif', 'image/webp']);
export const inlineImage = (file: File) => imageTypes.has(file.type) && file.size <= MAX_INLINE_IMAGE_BYTES;
export async function sendAttachment(store: string | null, threadId: string, file: File, text: string): Promise<string[]> {
  if (file.size > MAX_FILE_BYTES) throw new Error(FILE_TOO_BIG);
  if (!inlineImage(file)) return (await chatsApi.teamsFile(store, threadId, file, text)).notShared;
  const base64 = await new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => reject(new Error('that file could not be read'));
    reader.onload = () => resolve(String(reader.result).split(',')[1] ?? '');
    reader.readAsDataURL(file);
  });
  await chatsApi.teamsImage(store, threadId, { text, contentType: file.type, base64 });
  return [];
}
